$('#tmpl-instantsearch-hit').attr('data-cookieconsent', 'ignore');
$('#algolia-instantsearch-js').attr('data-cookieconsent', 'ignore');
$('#algolia-instantsearch-css').attr('data-cookieconsent', 'ignore');
$('#algolia-search-js').attr('data-cookieconsent', 'ignore');

$('#dkpdf-frontend-js').prev().attr('data-cookieconsent', 'ignore');

var minChars = 3;
var oriChars = minChars;

jQuery(function () {
    if (instantsearch && jQuery('#algolia-search-box').length > 0) {
        if (algolia.indices.searchable_posts === undefined && jQuery('.admin-bar').length > 0) {
            alert("It looks like you haven't indexed the searchable posts index. Please head to the Indexing page of the Algolia Search plugin and index it.");
        }

        let placeholder_text = jQuery('.placeholder--text').val();

        const algoliaClient = algoliasearch(algolia.application_id, algolia.search_api_key);

        const searchClient = {
            ...algoliaClient,
            search(requests) {
                if (requests.every(({ params }) => !params.query)) {
                    return Promise.resolve({
                        results: requests.map(() => ({
                            hits: [],
                            nbHits: 0,
                            nbPages: 0,
                            page: 0,
                            processingTimeMS: 0,
                            hitsPerPage: 0,
                            exhaustiveNbHits: false,
                            query: '',
                            params: '',
                        })),
                    });
                }
                return algoliaClient.search(requests);
            },
        };

        /* Instantiate instantsearch.js */
        var search = instantsearch({
            indexName: algolia.indices.searchable_posts.name,
            searchClient: searchClient,
        });

        const types = [
            { name: 'angebot', title: 'Angebote' },
            { name: 'news', title: 'Aktuelles' },
            { name: 'downloads', title: 'Downloads' },
            { name: 'referenz', title: 'Referenzen' },
            { name: 'mitarbeiter', title: 'Ansprechpartner' },
            { name: 'faq', title: 'FAQ' },
            { name: 'job', title: 'Jobs' },
            { name: 'lehrstelle', title: 'Lehrstellen' },
        ];

        const filteredHits = instantsearch.connectors.connectHits(function renderHits({ results, hits }, isFirstRender) {
            jQuery('#algolia-hits').html('');
            if (isFirstRender || !results || !results.query) {
                return;
            }
            let mytemplate = wp.template('instantsearch-hit');
            //console.log(hits);
            types.forEach((post_type) => {
                var subset = hits.filter((hit) => hit.post_type == post_type.name);
                //console.log(post_type,subset.length);
                if (subset && subset.length > 0) {
                    let teaser = subset.slice(0, 3);
                    var allitems = '<div class="teaser-hits"><h2>' + post_type.title + '</h2><div class="resluts--wrap">';
                    teaser.forEach((titem) => {
                        allitems += mytemplate(titem);
                    });
                    if (subset.length > 3) {
                        allitems +=
                            '<div><a class="btn-show-all" data-type="' +
                            post_type.name +
                            '" href="#">Weitere ' +
                            (subset.length - 3) +
                            ' ' +
                            post_type.title +
                            '</a></div></div></div><div class="all-hits hidden" id="all-' +
                            post_type.name +
                            '"><div><a class="btn-back" href="#">Zurück zur Übersicht</a><h2>Alle Ergebnisse aus ' +
                            post_type.title +
                            '</h2><div class="resluts--wrap">';
                        subset.forEach((item) => {
                            allitems += mytemplate(item);
                        });
                    }
                    jQuery('#algolia-hits').append(allitems + '</div></div>');
                }
            });

            jQuery('a.btn-show-all').click(function (e) {
                e.preventDefault();
                let post_type = e.target.dataset.type;
                jQuery('.teaser-hits').removeClass('block').addClass('hidden');
                jQuery('#all-' + post_type)
                    .addClass('block')
                    .removeClass('hidden');
                return false;
            });
            jQuery('a.btn-back').click(function (e) {
                e.preventDefault();
                jQuery('.all-hits').removeClass('block').addClass('hidden');
                jQuery('.teaser-hits').addClass('block').removeClass('hidden');
                return false;
            });
        });

        const qHook = function (query, search) {
            if (query.length > minChars && !query.match(/[^\x00-\x7F]/g) && !query.match(/<[a-z][\s\S]*>/i) && !query.includes('www.') && !query.includes('://')) {
                search(query);
                if (minChars < oriChars) {
                    minChars = oriChars;
                }
                jQuery('.ais-SearchBox-submit').hide();
                jQuery('.ais-SearchBox-reset').css('display', 'flex');
            } else {
                jQuery('.ais-SearchBox-reset').hide();
                jQuery('.ais-SearchBox-submit').show();
            }
        };

        search.addWidgets([
            /* Search box widget */
            instantsearch.widgets.searchBox({
                container: '#algolia-search-box',
                placeholder: placeholder_text,
                showReset: true,
                showSubmit: true,
                showLoadingIndicator: false,
                autofocus: true,
                queryHook: qHook,
            }),

            filteredHits(),
        ]);

        /* Start */
        search.start();

        jQuery('#algolia-search-box input').attr('type', 'search'); //.trigger( 'select' );
        jQuery('#algolia-search-box input').attr('id', 'lmSearchInputField');

        jQuery('.ais-SearchBox-submit').click(function () {
            minChars = 0;
            var query = $('#lmSearchInputField').val().trim();
            search.helper.setQuery(query).search();
        });
        jQuery('.ais-SearchBox-reset').click(function () {
            jQuery('#algolia-hits').html('');
        });
    }
});

$('.open--modal').click(function () {
    $('body').addClass('search-open');
    $('body').removeClass('search-closed');
    setTimeout(function () {
        $('#lmSearchInputField').focus();
    }, 500);
    event.stopPropagation();
});

$('.close--wrap').click(function () {
    removeSearch();
});

function removeSearch() {
    $('body').removeClass('search-open');
    $('body').addClass('search-closed');
}

$(document).on('click', function (event) {
    //if (!$(event.target).closest('.open--modal').length) {
    removeSearch();
    //}
});

$(document).on('keydown', function (event) {
    minChars = 2;
});

$('#ais-main').on('click', function (event) {
    event.stopPropagation();
});

class ClassWatcher {
    constructor(targetNode, classToWatch, classAddedCallback, classRemovedCallback) {
        this.targetNode = targetNode;
        this.classToWatch = classToWatch;
        this.classAddedCallback = classAddedCallback;
        this.classRemovedCallback = classRemovedCallback;
        this.observer = null;
        this.lastClassState = targetNode.classList.contains(this.classToWatch);

        this.init();
    }

    init() {
        this.observer = new MutationObserver(this.mutationCallback);
        this.observe();
    }

    observe() {
        this.observer.observe(this.targetNode, { attributes: true });
    }

    disconnect() {
        this.observer.disconnect();
    }

    mutationCallback = (mutationsList) => {
        for (let mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                let currentClassState = mutation.target.classList.contains(this.classToWatch);
                if (this.lastClassState !== currentClassState) {
                    this.lastClassState = currentClassState;
                    if (currentClassState) {
                        this.classAddedCallback();
                    } else {
                        this.classRemovedCallback();
                    }
                }
            }
        }
    };
}

function openSearch() {
    // console.log("search open");
    $('html, body').css({
        overflow: 'hidden',
    });
    //$('body').removeClass('preload');
}

function closeSearch() {
    // console.log("search closed");
    $('html, body').css({
        overflow: 'auto',
    });
    //$('body').removeClass('preload');
}

let classWatcher = new ClassWatcher(document.body, 'search-open', openSearch, closeSearch);
